(function($) {

	'use strict';

	var init = function() {
		initFooterNav();
        $( window ).resize(function(){
            initNavResize();
        });
        
        $( window ).resize();
	};

	var initFooterNav = function() {
        $(".footer-menu__listZone .arrow").on("click", function (e) {
            e.preventDefault();
            $(this).toggleClass('open');
            $(this).parent().parent().next('ul').slideToggle();
        });
	};
    
    var initNavResize = function(){
        if(window.matchMedia("(min-width: 768px)").matches){
            $(".footer-menu__listZone ul").attr('style', '');
            $(".footer-menu__listZone .arrow").removeClass('open');
        }
        else{
            
        }
    };

	$(document).ready(function() {
		init();
	});

})(jQuery);
